import { render, staticRenderFns } from "./MaternalVideo.vue?vue&type=template&id=0640c472&scoped=true"
import script from "./MaternalVideo.vue?vue&type=script&lang=js"
export * from "./MaternalVideo.vue?vue&type=script&lang=js"
import style0 from "./MaternalVideo.vue?vue&type=style&index=0&id=0640c472&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0640c472",
  null
  
)

export default component.exports